import { render, staticRenderFns } from "./Winning.vue?vue&type=template&id=2ddcf3da&scoped=true"
import script from "./Winning.vue?vue&type=script&lang=js"
export * from "./Winning.vue?vue&type=script&lang=js"
import style0 from "./Winning.vue?vue&type=style&index=0&id=2ddcf3da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ddcf3da",
  null
  
)

export default component.exports